import React, { useEffect } from "react";
import { Card, DatePicker, Form, Button, message, notification } from "antd";
import dayjs from "dayjs";
import GestionCalendrierExamens from "./GestionCalendrierExamens";
import { useLoader } from "../../../../context/LoaderContext";
import { checkDecalageCalendrier } from "../../../../api/geoprod";
import { useTranslation } from "react-i18next";

const { RangePicker } = DatePicker;

const GestionCalendrierExamensCarte = ({
  form,
  modules,
  setModules,
  title,
  dateDebut,
  dateFin,
  type,
  scheduled,
  setScheduled,
  showCalendar,
  setShowCalendar,
  dates,
  setDates,
  id_calendrier,
  id_affaire
}) => {
  const startDateKey = `startDate${type}`;
  const endDateKey = `endDate${type}`;
  const { t } = useTranslation();
  const { setIsLoading } = useLoader();
  const handleConfirm = () => {
    form
      .validateFields()
      .then(() => {
       
      const payload =
        {
          "id_calendrier":id_calendrier,
          "id_affaire":id_affaire,
          "date_debut":(form?.getFieldValue(startDateKey)).format("YYYY-MM-DD"),
          // "max_semaine":200
        }
       
        checkDecalageCalendrier(payload)
          .then((response) => {

        if (type === "examen") {
        setModules(JSON.parse(sessionStorage.getItem("globalData"))?.modulesExamensSession)
        setScheduled([])
        }
        else 
         {
        setModules(JSON.parse(sessionStorage.getItem("globalData"))?.modulesRattrapagesSession)
               setScheduled([])
        } 
            notification.success({
              description: t("Période validée avec succès. Veuillez maintenant planifier chaque module sur les jours affichés, entre la date de début et la date de fin."),
              duration: 0,
            });
            setShowCalendar(true);
            setIsLoading(false);
          })
          .catch((error) => {
            console.log(error)
            notification?.error({
              message: t("Erreur"),
              description: t(error?.data?.message),
              duration: 0,
            });
            setShowCalendar(false);
            setIsLoading(false);
          });
      })
      .catch(() => {
        setShowCalendar(false);
        message.error("Veuillez remplir les deux dates.");
      });
  };
const handleDateChange = (key, date) => {
    setDates((prevDates) => ({
      ...prevDates,
      [type]: {
        ...prevDates[type],
        [key]: date ? date.format("DD/MM/YYYY") : null,
      },
    }));
    setShowCalendar(false);
  };


  useEffect(() => {
  if (dates[type]?.startDate || dates[type]?.endDate) {
    form.setFieldsValue({
      [startDateKey]: dates[type]?.startDate ? dayjs(dates[type].startDate, "DD/MM/YYYY") : null,
      [endDateKey]: dates[type]?.endDate ? dayjs(dates[type].endDate, "DD/MM/YYYY") : null,
    });
  }
}, [dates, type]);

  return (
    <div>
      <Card
        title="Sélectionner une période"
        style={{ borderRadius: 12, boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}
      >
       
          <Form.Item
            name={startDateKey}
            label={`Date de début ${type ? `(${type})` : ""}`}
            rules={[
              {
                required: true,
                message: "Veuillez sélectionner la date de début.",
              },
            ]}
          >
            <DatePicker
              format="DD/MM/YYYY"
              style={{ width: "100%" }}
              placeholder="Date de début"
               onChange={(date) => handleDateChange("startDate", date)}
              disabledDate={(current) =>
                current && current < dayjs().startOf("day")
              }
            />
          </Form.Item>

          <Form.Item
            name={endDateKey}
            label={`Date de fin ${type ? `(${type})` : ""}`}
            rules={[
              {
                required: true,
                message: "Veuillez sélectionner la date de fin.",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const startDate = getFieldValue(startDateKey);
                  if (!value || !startDate || value.isAfter(startDate)) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error(
                      "La date de fin doit être supérieure à la date de début."
                    )
                  );
                },
              }),
            ]}
          >
            <DatePicker
              format="DD/MM/YYYY"
              style={{ width: "100%" }}
              placeholder="Date de fin"
               onChange={(date) => handleDateChange("endDate", date)}
              disabledDate={(current) =>
                current && current < dayjs().startOf("day")
              }
            />
          </Form.Item>

          <Form.Item>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                type="primary"
                onClick={handleConfirm}
                style={{ width: 200 }}
                disabled={showCalendar}
              >
                Confirmer
              </Button>
            </div>
          </Form.Item>
      </Card>

      {showCalendar && (
        <GestionCalendrierExamens
          form={form}
          modules={modules}
          setModules={setModules}
          title={title}
          dateDebut={dates[type]?.startDate}
          dateFin={dates[type]?.endDate}
          type={type}
          scheduled={scheduled}
          setScheduled={setScheduled}
        />
      )}
    </div>
  );
};

export default GestionCalendrierExamensCarte;
